var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('page-header'),_vm._v(" game "),(_vm.$route.meta.hasFooter)?_c('page-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }